import React from "react";

/**
 * Branded fallback for experiences with no images uploaded yet.
 * Renders pure CSS — no external image fetch, always loads instantly.
 */
export default function ExperiencePlaceholder({ className = "", showLabel = true }) {
  return (
    <div
      className={`relative w-full h-full overflow-hidden ${className}`}
      style={{
        background:
          "linear-gradient(135deg, #0A0A0A 0%, #1f1d18 50%, #2b2620 100%)",
      }}
      data-testid="experience-placeholder"
    >
      {/* Subtle decorative diagonal stripes */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "repeating-linear-gradient(135deg, rgba(201,185,138,0.05) 0px, rgba(201,185,138,0.05) 1px, transparent 1px, transparent 14px)",
        }}
      />
      <div
        className="absolute inset-0 flex flex-col items-center justify-center gap-2 text-center px-4"
        style={{ color: "#F5F3EC" }}
      >
        <div
          style={{
            fontFamily: "Georgia, 'Times New Roman', serif",
            fontSize: "1.25rem",
            letterSpacing: "0.22em",
            fontWeight: 400,
          }}
        >
          BENOVA
        </div>
        <div
          style={{
            fontSize: "0.55rem",
            letterSpacing: "0.45em",
            color: "#C9B98A",
            textTransform: "uppercase",
          }}
        >
          Travel Group
        </div>
        {showLabel && (
          <div
            className="mt-3 text-[10px] opacity-60"
            style={{ letterSpacing: "0.15em", textTransform: "uppercase" }}
          >
            Riviera Maya
          </div>
        )}
      </div>
    </div>
  );
}
